module.exports = __webpack_public_path__ + "static/media/usersmanage.6517f3fc.svg";